module.exports = __webpack_public_path__ + "static/iot-dcc31cf18110346e5876e480177199a3.jpeg";